import { jssPreset, StylesProvider as MuiProvider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { create } from 'jss';
import rtl from 'jss-rtl';
import React from 'react';

import { CircularXXWebBook, CircularXXWebMedium } from './fonts';

// taking a subset of the css baseline config
// https://github.com/mui/material-ui/blob/9fb11b6f487d012fadc880c3e9fcd636a4aa3a88/packages/material-ui/src/CssBaseline/CssBaseline.js#L34
export const useStyles = makeStyles(theme => ({
  '@global': {
    '@font-face': [
      {
        fontFamily: 'CircularXXWeb',
        src: `url(${CircularXXWebBook}) format("woff")`,
      },
      {
        fontFamily: 'CircularXXWeb',
        fontWeight: 500,
        src: `url(${CircularXXWebMedium}) format("woff")`,
      },
    ],
    html: {
      boxSizing: 'border-box',
    },
    /**
     * N.B. setting `boxSizing` to `border-box` is probably better,
     * this gets us easier to read viz diffs for AX-568!
     * @see {@link https://fountain.atlassian.net/browse/AX-599}
     */
    '*, *::before, *::after': {
      boxSizing: 'inherit',
    },
    body: {
      fontFamily: theme.typography.fontFamily,
      margin: 0, // Remove the margin in all browsers.
    },
    'b, strong': {
      fontWeight: 500,
    },
  },
}));

type MuiProps = React.ComponentProps<typeof MuiProvider>;

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// Initialize the MUI StylesProvider with a css reset
export const StylesProvider: React.FC<MuiProps> = props => {
  useStyles();
  return <MuiProvider {...props} jss={jss} />;
};
